import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { DENOMINATIONS } from '../../../utils/constants';

import { fetchCassetteData, updateCassetteData } from '../../../redux/actions/ProcessorTerminalActions';
import { Panel, PanelHeader, PanelBody } from '../../header/panel/panel';

const ProcessorTerminalCassetteData = (props) => {

    const [processorTermID, setProcessorTermID] = useState('')

    const [denoA, setDenoA] = useState('')
    const [denoB, setDenoB] = useState('')
    const [denoC, setDenoC] = useState('')
    const [denoD, setDenoD] = useState('')

    const [denoALoaded, setDenoALoaded] = useState(0)
    const [denoBLoaded, setDenoBLoaded] = useState(0)
    const [denoCLoaded, setDenoCLoaded] = useState(0)
    const [denoDLoaded, setDenoDLoaded] = useState(0)

    const [denoADispensed, setDenoADispensed] = useState(0)
    const [denoBDispensed, setDenoBDispensed] = useState(0)
    const [, setDenoCDispensed] = useState(0)
    const [, setDenoDDispensed] = useState(0)

    const [denoANextLoad, setDenoANextLoad] = useState(0)
    const [denoBNextLoad, setDenoBNextLoad] = useState(0)

    const [loadNow, setLoadNow] = useState(false)

    const [resetValue, setResetValue] = useState(0);

    const [denoAError] = useState(false)
    const [denoBError] = useState(false)
    const [denoCError] = useState(false)
    const [denoDError] = useState(false)
    useState(false)
    useState(false)
    useState(false)
    useState(false)
    const [resetValueError] = useState(false);

    useState(false)
    useState(false)


    const [edit, setEdit] = useState(false)

    const [, setReload] = useState(false)
    // const [toggleReload, setToggleReload] = useState(true)

    useEffect(() => {

        setDenoA(props.TERMINALREDUCER.cassetteData.denoA)
        setDenoB(props.TERMINALREDUCER.cassetteData.denoB)
        setDenoC(props.TERMINALREDUCER.cassetteData.denoC)
        setDenoD(props.TERMINALREDUCER.cassetteData.denoD)


        setDenoALoaded(props.TERMINALREDUCER.cassetteData.denoALoaded)
        setDenoBLoaded(props.TERMINALREDUCER.cassetteData.denoBLoaded)
        setDenoCLoaded(props.TERMINALREDUCER.cassetteData.denoCLoaded)
        setDenoDLoaded(props.TERMINALREDUCER.cassetteData.denoDLoaded)

        setDenoADispensed(props.TERMINALREDUCER.cassetteData.denoADispensed)
        setDenoBDispensed(props.TERMINALREDUCER.cassetteData.denoBDispensed)
        setDenoCDispensed(props.TERMINALREDUCER.cassetteData.denoCDispensed)
        setDenoDDispensed(props.TERMINALREDUCER.cassetteData.denoDDispensed)

        setDenoANextLoad(props.TERMINALREDUCER.cassetteData.denoANextLoad)
        setDenoBNextLoad(props.TERMINALREDUCER.cassetteData.denoBNextLoad)

        setResetValue(props.TERMINALREDUCER.cassetteData.resetAmount)
        setLoadNow(false)

    }, [props.TERMINALREDUCER?.cassetteData])

    useEffect(() => {

    }, [edit])


    const handleChange = (event) => {

        let targetName = event.target.name
        let targetValue = event.target.value

        switch (targetName) {

            case 'denoA':
                setDenoA(targetValue)
                break;
            case 'denoB':
                setDenoB(targetValue)
                break;
            case 'denoC':
                setDenoC(targetValue)
                break;
            case 'denoD':
                setDenoD(targetValue)
                break;
            case 'denoALoaded':
                setDenoALoaded(targetValue)
                break;
            case 'denoBLoaded':
                setDenoBLoaded(targetValue)
                break;
            case 'denoCLoaded':
                setDenoCLoaded(targetValue)
                break;
            case 'denoDLoaded':
                setDenoDLoaded(targetValue)
                break;

            case 'denoANextLoad':
                setDenoANextLoad(targetValue)
                break;
            case 'denoBNextLoad':
                setDenoBNextLoad(targetValue)
                break;

            case 'resetValue':
                setResetValue(targetValue)
                break;
            default:
                break;
        }
    }

    const handleSubmit = (event) => {

        event.preventDefault();

        let body = {}

        if (processorTermID) {
            body.processorTermID = processorTermID
        }

        // if(denoA && denoALoaded) {
        body.denoA = denoA
        body.denoALoaded = denoALoaded
        body.denoANextLoad = denoANextLoad
        // }else {
        // setDenoAError(true)
        // }

        // if(denoA && denoALoaded) {
        body.denoB = denoB
        body.denoBLoaded = denoBLoaded
        body.denoBNextLoad = denoBNextLoad

        // }else {
        // setDenoBError(true)
        // }
        // if(denoA && denoALoaded) {
        body.denoC = denoC
        body.denoCLoaded = denoCLoaded
        // }else {
        // setDenoCError(true)
        // }
        // if(denoA && denoALoaded) {
        body.denoD = denoD
        body.denoDLoaded = denoDLoaded

        body.loadNow = loadNow

        body.resetAmount = resetValue

        // }else {
        // setDenoDError(true)
        // }
        if (!denoAError && !denoBError && !denoCError && !denoDError) {
            console.log('Body : ' + body)
            setReload(true)
            props.updateCassetteData(body)
            setEdit(false)
            setReload(false)
            setLoadNow(false)
        }

    }

    const handleLoadNow = (event) => {
        setLoadNow(!loadNow)
    }

    const editCassette = () => {

        props.fetchCassetteData(props.processorTermID)

        let data = props.TERMINALREDUCER.cassetteData;

        console.log('data : ' + data.processorTermID)

        setProcessorTermID(props.processorTermID)

        setDenoA(data.denoA)
        setDenoB(data.denoB)
        setDenoC(data.denoC)
        setDenoD(data.denoD)


        setDenoALoaded(data.denoALoaded)
        setDenoBLoaded(data.denoBLoaded)
        setDenoCLoaded(data.denoCLoaded)
        setDenoDLoaded(data.denoDLoaded)

        setDenoADispensed(data.denoADispensed)
        setDenoBDispensed(data.denoBDispensed)
        setDenoCDispensed(data.denoCDispensed)
        setDenoDDispensed(data.denoDDispensed)

        setResetValue(data.resetAmount)


        setEdit(!edit)

    }

    let CASSETTE_FORM = (

        <div className="mb-3">

            <div className="row gx-3">

                <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                        <tbody>
                            <tr>
                                <td style={{ width: '12%' }}>

                                </td>

                                <td style={{ width: '20%' }}><label className={"col-md-12 "}> <b>Denomination</b></label> </td>
                                <td style={{ width: '20%' }}><label className={"col-md-12 "}> <b>Loaded</b></label> </td>
                                <td style={{ width: '20%' }}><label className={"col-md-12 "}> <b>Dispensed</b></label> </td>
                                <td style={{ width: '20%' }}><label className={"col-md-12 "}> <b>Next Load</b></label> </td>

                            </tr>

                            <tr>

                                <td><label className={"col-md-12"}> <b>Cassette A</b></label> </td>

                                <td>  <select className="form-control fs-13px"
                                    onChange={handleChange}
                                    name='denoA'
                                    value={denoA ? denoA : ''}
                                    disabled={!edit}
                                >
                                    {DENOMINATIONS.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.value}
                                        </option>
                                    ))}
                                </select>
                                </td>

                                <td>
                                    <input type="text" className="form-control fs-13px"
                                        name="denoALoaded"
                                        onChange={handleChange}
                                        value={denoALoaded ? denoALoaded : ''}
                                        disabled={true}
                                    /></td>


                                <td>
                                    <input type="text" className="form-control fs-13px"
                                        name="denoADispensed"
                                        onChange={handleChange}
                                        value={denoADispensed ? denoADispensed : 0}
                                        disabled={true}
                                    /></td>


                                <td>
                                    <input type="text" className="form-control fs-13px"
                                        name="denoANextLoad"
                                        onChange={handleChange}
                                        value={denoANextLoad ? denoANextLoad : 0}
                                        disabled={!edit}
                                    /></td>

                            </tr>


                            <tr>

                                <td><label className={"col-md-12"}> <b> Cassette B </b></label> </td>

                                <td>  <select className="form-control fs-13px"
                                    onChange={handleChange}
                                    name='denoB'
                                    value={denoB ? denoB : ' '}
                                    disabled={!edit}
                                >
                                    {DENOMINATIONS.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.value}
                                        </option>
                                    ))}
                                </select>
                                </td>

                                <td>
                                    <input type="text" className="form-control fs-13px"
                                        name="denoBLoaded"
                                        onChange={handleChange}
                                        value={denoBLoaded ? denoBLoaded : 0}
                                        disabled={true}
                                    /></td>


                                <td>
                                    <input type="text" className="form-control fs-13px"
                                        name="denoBDispensed"
                                        onChange={handleChange}
                                        value={denoBDispensed ? denoBDispensed : 0}
                                        disabled={true}
                                    /></td>


                                <td>
                                    <input type="text" className="form-control fs-13px"
                                        name="denoBNextLoad"
                                        onChange={handleChange}
                                        value={denoBNextLoad ? denoBNextLoad : 0}
                                        disabled={!edit}
                                    /></td>



                            </tr>





                        </tbody>
                    </table>
                </div>

            </div>

            <br></br>


            <div className="mb-3">

                <div className="row gx-6">

                    <div className="col-md-2 mb-2 mb-md-0">
                        <label className={"col-md-12 " + (resetValueError ? 'text-danger' : '')}><b>Reset Amount</b></label>
                        <input type="text" className="form-control fs-13px"
                            name="resetValue"
                            onChange={handleChange}
                            value={resetValue ? resetValue : ''}
                            disabled={!edit}
                        />
                    </div>
                    <div className="col-md-3 mb-2 mb-md-0">
                        <label className="form-check-label" >
                            <b>
                                Load now
                            </b>
                            &nbsp;&nbsp;&nbsp;
                            <input className="form-check-input" type="checkbox" checked={loadNow} onChange={handleLoadNow} >
                            </input>
                        </label>
                    </div>

                    <div className="col-md-3 mb-2 mb-md-0">
                        <button className='btn btn-primary d-block w-100 btn-lg h-9px fs-13px' onClick={handleSubmit}>{'Update'}</button>
                    </div>

                </div>
            </div>

        </div>

    )


    return (

        <Panel>

            <PanelHeader>

                <div className="row mb-0">

                    <div className="col-xl-4">
                        Terminal Cassette Data
                    </div>
                    <div className="col-xl-7">

                    </div>
                    <div className="col-xl-1">
                        <button className='btn btn-xs btn-secondary d-block w-40 btn-lg fs-09px' onClick={editCassette}>{!edit ? 'Edit' : 'Cancel'}</button>
                    </div>

                </div>



            </PanelHeader>

            <PanelBody>
                {CASSETTE_FORM}


            </PanelBody>

        </Panel>
    )



}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {

    fetchCassetteData,
    updateCassetteData

}


export default connect(mapStateToProps, mapDispatchToProps)(ProcessorTerminalCassetteData);
